import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { from, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccessGuard implements CanActivate {
  constructor(private router: Router, private keycloakSrv: KeycloakService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const guest = route.data['guest'] as boolean;
    return from(this.keycloakSrv.isLoggedIn()).pipe(
      map((logged: boolean) => {
        if (guest) {
          if (logged) {
            return this.router.parseUrl('/servizi');
          }
          return true;
        } else {
          if (logged) {
            return true;
          }
          return this.router.parseUrl('/');
        }
      })
    );
  }
}
